<script lang="ts">
    import { redirectTo } from "../scripts/router1";
    import { idPageEntreprise } from "../scripts/router2";
    import type { User } from '../scripts/user';
    import { Enterprise, storeEnterpriseId, storeEnterprises, emptyEnterprise } from "../scripts/enterprise";
    import { beforeUpdate, onMount } from "svelte";

    export let propsUser: User;
    export let propsDisplayEnterprise: boolean;

    let bgHover: boolean = false;
    let sonEntreprise: Enterprise;

    /**
     * backgroundPhoto
     */backgroundPhoto
    function backgroundPhoto() {
        const photo = document.getElementById("idPhotoDesktop-"+propsUser.id);
        let url = "";
        if (propsUser.photo == undefined || propsUser.photo == null || propsUser.photo == "") {
            url = "url('../assets/images/users/avatar.png')";    
        } else {
            url = "url('../assets/images/users/"+propsUser.id+"_"+propsUser.photo+"')";    
        }
        photo.style.backgroundImage = url;
        bgHover = false;
    }

    /**
     * backgroundHover
     */
    function backgroundHover() {
        const photo = document.getElementById("idPhotoDesktop-"+propsUser.id);
        photo.style.backgroundImage = "none";
        bgHover = true;
    }

    beforeUpdate(() => {
        sonEntreprise = $storeEnterprises.filter((oneEntreprise) => oneEntreprise.id == propsUser.enterprise)[0];
        if (sonEntreprise == undefined) {
            sonEntreprise = emptyEnterprise;
        }
	});

    onMount(async () => {
        const photoMobile = document.getElementById("idPhotoMobile-"+propsUser.id);
        const photoDesktop = document.getElementById("idPhotoDesktop-"+propsUser.id);
        let url = "";
        if (propsUser.photo == undefined || propsUser.photo == null || propsUser.photo == "") {
            url = "url('../assets/images/users/avatar.png')";    
        } else {
            url = "url('../assets/images/users/"+propsUser.id+"_"+propsUser.photo+"')";    
        }
        photoMobile.style.backgroundImage = url;
        photoDesktop.style.backgroundImage = url;
        window.scrollTo(0,0);
	});

    /**
     * selectEnterprise
     * @param id
     */
    function selectEnterprise(id) {
        storeEnterpriseId.set(id);
        redirectTo(idPageEntreprise);
    }

</script>

<style lang="scss">

	.tilemember {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 32px 32px 76px 32px;
        width: 350px;
        height: 400px;
        &__mobile {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        &__desktop {
            display: none;
        }
        &__photo {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            border-radius: 50%;
            padding: 8px 8px 8px 8px;
            width: 300px;
            height: 300px;
            box-sizing: border-box;
        }
        &__icons {
            display: none;
            &__display {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
            }
        }
        &__icon {
            width: 20px;
            height: 20px;
            background-size: cover;
			background-repeat: no-repeat;
            transition: all 1s;
            cursor: pointer;
            padding: 8px 8px 8px 8px;
        }
        &__twitter {
            background-image: url("../assets/images/logo-twitter-orange.png");
        }
        &__linkedin {
            background-image: url("../assets/images/logo-linkedin-orange.png");
        }
        &__link {
            color: $color_primary;
        }
        &__text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
        }
    }

    @include large {
        .tilemember {
            margin: 0;
            padding: 32px 50px 32px 50px;
            width: 250px;
            height: 250px;
            &__mobile {
                display: none;
            }
            &__desktop {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            &__photo {
                cursor: pointer;
                transition: all 1s;
                width: 150px;
                height: 150px;
                &:hover {
                    background-color: $color_primary;
                    border: 2px solid $color_orange;
                }
            }
            &__photoempty {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                border-radius: 50%;
                padding: 8px 8px 8px 8px;
                box-sizing: border-box;
                cursor: default;
                width: 150px;
                height: 150px;
            }
            &__link {
                cursor: pointer;
                &:hover {
                    color: $color_orange;
                }
            }
        }
    }

</style>

<div class="tilemember">
    <div class="tilemember__mobile">
        <div class="tilemember__photo" id="idPhotoMobile-{propsUser.id}">
        </div>    
        <div class="tilemember__text font__h3">{propsUser.first_name}&nbsp;{propsUser.last_name}</div>
        {#if (propsUser.job != undefined && propsUser.job != null)}
        <div class="tilemember__text">{propsUser.job}</div>
        {/if}
        {#if propsDisplayEnterprise}
        <div class="tilemember__text tilemember__link" on:click={() => selectEnterprise(sonEntreprise.id)} on:keydown={() => selectEnterprise(sonEntreprise.id)}>{sonEntreprise.name}</div>
        {/if} 
        {#if (propsUser.twitter != undefined && propsUser.twitter != "")}
        <a href={propsUser.twitter} target="_blank">
            <div class="tilemember__icon tilemember__twitter"></div>
        </a>
        {/if}
        {#if (propsUser.linkedin != undefined && propsUser.linkedin != "")}
        <a href={propsUser.linkedin} target="_blank">
            <div class="tilemember__icon tilemember__linkedin"></div>    
        </a>
        {/if}
    </div>
    <div class="tilemember__desktop">
        {#if ((propsUser.linkedin == undefined || propsUser.linkedin == "") && (propsUser.twitter == undefined || propsUser.twitter == ""))}
        <div class="tilemember__photoempty" id="idPhotoDesktop-{propsUser.id}">
        </div>
        {:else}
        <div class="tilemember__photo" id="idPhotoDesktop-{propsUser.id}" on:mouseover={() => backgroundHover()} on:focus={() => backgroundHover()} on:mouseout={() => backgroundPhoto()} on:blur={() => backgroundPhoto()}>
            <div class="tilemember__icons" class:tilemember__icons__display={bgHover}>
                {#if (propsUser.twitter != undefined && propsUser.twitter != "")}
                <a href={propsUser.twitter} target="_blank">
                    <div class="tilemember__icon tilemember__twitter"></div>
                </a>
                {/if}
                {#if (propsUser.linkedin != undefined && propsUser.linkedin != "")}
                <a href={propsUser.linkedin} target="_blank">
                    <div class="tilemember__icon tilemember__linkedin"></div>    
                </a>
                {/if}
            </div>
        </div>
        {/if}
        <div class="tilemember__text font__h3">{propsUser.first_name}&nbsp;{propsUser.last_name}</div>
        {#if (propsUser.job != undefined && propsUser.job != null)}
        <div class="tilemember__text">{propsUser.job}</div>
        {/if}
        {#if (propsDisplayEnterprise && sonEntreprise.id != 99)}
        <div class="tilemember__text tilemember__link" on:click={() => selectEnterprise(sonEntreprise.id)} on:keydown={() => selectEnterprise(sonEntreprise.id)}>{sonEntreprise.name}</div>            
        {/if}
    </div>
</div>
